import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AvisContext } from "../../context";

interface IAvisPageTitleProps {
  title: string | undefined;
}
export function AvisPageTitle(props: Readonly<IAvisPageTitleProps>) {
  const { title } = props;
  const { res } = useContext(AvisContext);
  const location = useLocation();

  useEffect(() => {
    if (!title) return;

    const portalSuffix = res("label_portalTitle");
    document.title = `${title} - ${portalSuffix}`;
  }, [location, res, title]);
  return null;
}
